require("./prognosis.less");
import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');

class PrognosisController {
    promise;
    prognosisDataSet;
    activeParams;

    searchDefinition ={
        fields:[
            {title:'År', name: 'year', type:'number', required: true},
            {title:'Vare', name: 'articleNoOrName', type:'text'},
            {title:'Leverandør', name: 'supplierNoOrName', type:'text'},
            {title:'Varegruppe', name: 'articleGroup', type:'text'},
            {title:'Salgsvarer', name: 'onlySalesItems', type:'checkbox'}
        ],
        fieldsLength: 20,
        addTopPadding: true,
        smallFab: true,
        searchFunction:(params) => this.getPrognosisLines(params),
        searchParams: {},
    };

    months = [
        {title:'Januar', name:'januar'},
        {title:'Februar', name:'februar'},
        {title:'Mars', name:'mars'},
        {title:'April', name:'april'},
        {title:'Mai', name:'mai'},
        {title:'Juni', name:'juni'},
        {title:'Juli', name:'juli'},
        {title:'August', name:'august'},
        {title:'September', name:'september'},
        {title:'Oktober', name:'oktober'},
        {title:'November', name:'november'},
        {title:'Desember', name:'desember'},
    ];

    filterButtons = [
        {name: "Prognose salg", active: true, id: 1},
        {name: "PO Mottatt", active: true, id: 3},
        {name: "Salg i år", active: true, id: 4},
        {name: "Salg i fjor", active: true, id: 5}
    ];

    openContextMenu (openmenu, ev) {
        openmenu(ev);
    };


    constructor(private toastService, private $mdDialog, private Prognosis, private $location){
    }

    $onInit () { };

    calculateSums(startIndex) {
        for(var i = startIndex; i < this.prognosisDataSet.length; i++){
            var line = this.prognosisDataSet[i];
            if(line.code === 'SUM'){
                if(line.forecastLine.months){
                    for(var y = 0; y < line.forecastLine.months.length; y++){
                        line.forecastLine.months[y].forecastSum = this.findValueForSumField(i, y);
                    }
                }
                line.totalSum = this.findTotalSumForSumLine(i);
            }else{
                line.totalSum = this.findTotalSumForLine(line);
            }
        }
    }

    getPrognosisLines (params){
        var paramsCopy = angular.copy(params);
        paramsCopy.pageNo = 0;
        paramsCopy.pageSize = 10;
        this.promise = this.Prognosis.search(paramsCopy).$promise.then((result) => {
            this.prognosisDataSet = _.flatMap(result.content, item => item.forecastTypes.map(x => {
                x.articleNo = item.articleNo;
                x.uid = x.articleNo + "_" + x.id;
                if(x.code === 'PO_PROGNOSIS'){
                    x.stockStartOfYear = item.stockStartOfYear;
                    x.stockValue = item.stockValue;
                }
                return x
            }));
            this.calculateSums(0);
            this.activeParams = paramsCopy;
        },(error) => {this.toastService.parseError(error);});
    }

    getMorePrognosisLines (){
        this.activeParams.pageNo += 1;
        this.promise = this.Prognosis.search(this.activeParams).$promise.then((result) => {
            var temp = _.flatMap(result.content, item => item.forecastTypes.map(x => {
                x.articleNo = item.articleNo;
                x.uid = x.articleNo + "_" + x.id;
                if(x.code === 'PO_PROGNOSIS'){
                    x.stockStartOfYear = item.stockStartOfYear;
                    x.stockValue = item.stockValue;
                }
                return x
            }));
            this.prognosisDataSet.push(...temp);
            //Multiplied by 8 because thats the amount of rows per page.
            //Done so it only calculates the new rows pushed to this.prognosisDataSet and not the already calculated ones.
            var startIndex = this.activeParams.pageNo * this.activeParams.pageSize * 8;
            this.calculateSums(startIndex);
        },(error) => {
            this.toastService.parseError(error);
        });
    };

    filterFunction (buttons) {
        return (line) => {
            var button = buttons.find(function(button){
                return button.id === line.id;
            });
            if(button){
                return button.active;
            }else {
                return true;
            }
        };
    };

    inputValChanged (line, month, sectionIndex){
        this.Prognosis.forecast({articleNo: line.articleNo, forecast: line.forecastLine.months[month].forecastSum, forecastTypeId: line.id, month: month + 1, year: this.activeParams.year}).$promise.then(
            () => {
                line.totalSum = this.findTotalSumForLine(line);
                if(line.code === 'PO_CONFIRMED'){
                    //Always line.code==='SUM' on sectionIndex+1 to sum up per 1k NOK
                    this.prognosisDataSet[sectionIndex + 1].forecastLine.months[month].forecastSum = this.findValueForSumField(sectionIndex + 1, month);
                    this.prognosisDataSet[sectionIndex + 1].totalSum = this.findTotalSumForSumLine(sectionIndex + 1);
                }
            },
            (error) => { this.toastService.parseError(error); }
        );
    };

    inputLineChanged (line, sectionIndex){
        line.totalSum = this.findTotalSumForLine(line);
        if(line.code === 'PO_CONFIRMED'){
            if(this.prognosisDataSet[sectionIndex + 1].forecastLine.months){
                for(var y = 0; y < this.prognosisDataSet[sectionIndex + 1].forecastLine.months.length; y++){
                    this.prognosisDataSet[sectionIndex + 1].forecastLine.months[y].forecastSum = this.findValueForSumField(sectionIndex + 1, y);
                }
            }
            this.prognosisDataSet[sectionIndex + 1].totalSum = this.findTotalSumForSumLine(sectionIndex + 1);
        }
    };

    addCampaignToLine (line, ev){
        var _this = this;
        this.$mdDialog.show({
            template: '<add-campaigns-dialog active-year="c.activeYear" active-line="c.activeLine"></add-campaigns-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
                this.activeYear = _this.activeParams.year;
            }],
        });
    };

    findTotalSumForLine (line) {
        var total = 0;
        if(line && line.forecastLine && line.forecastLine.months){
            line.forecastLine.months.forEach(function(month){
                if(month.forecastSum){
                    total += parseInt(month.forecastSum);
                }
            });
            return total;
        }else{
            return 0;
        }
    };

    findTotalSumForSumLine (sectionIndex) {
        return (this.findTotalSumForLine(this.prognosisDataSet[sectionIndex - 1]) * (this.prognosisDataSet[sectionIndex].attributes[0].value)) / 1000;
    };

    showNotesForYear (line,ev){
        this.$mdDialog.show({
            template: '<show-notes-dialog active-line="c.activeLine"></show-notes-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
            }],
        });
    };

    showDistributionKeyDialog (line, ev, sectionIndex){
        var _this = this;
        this.$mdDialog.show({
            template: '<distribute-with-key-dialog active-year="c.activeYear" active-line="c.activeLine"></distribute-with-key-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
                this.activeYear = _this.activeParams.year;
            }],
        }).then(() => {
            this.inputLineChanged(line, sectionIndex);
        });
    };

    writeNote (line, ev, month){
        var _this = this;
        this.$mdDialog.show({
            template: '<enter-note-dialog active-year="c.activeYear" active-month="c.activeMonth" active-line="c.activeLine"></enter-note-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
                this.activeMonth = month;
                this.activeYear = _this.activeParams.year;
            }],
        });
    };

    showHistoryForField (line, ev, month){
        const _this = this;
        this.$mdDialog.show({
            template: '<show-history-dialog active-month="c.activeMonth" active-line="c.activeLine"></show-history-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
                this.activeMonth = month;
            }],
        });
    };

    editDays (line, ev, month, sectionIndex){
        var _this = this;
        this.$mdDialog.show({
            template: '<edit-days-dialog active-year="c.activeYear" active-month="c.activeMonth" active-line="c.activeLine"></edit-days-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeLine = line;
                this.activeMonth = month;
                this.activeYear = _this.activeParams.year;
            }],
        }).then(() => {
            this.inputLineChanged(line, sectionIndex);
        });
    };

    findValueForSumField (sectionIndex, monthIndex) {
        return ((this.prognosisDataSet[sectionIndex - 1].forecastLine.months[monthIndex].forecastSum * this.prognosisDataSet[sectionIndex].attributes[0].value) / 1000)
    };
}

class PrognosisOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcPrognosisController";
    public template: any = require('./prognosis.html');
}

rkcApp.controller("rkcPrognosisController", ['toastService', '$mdDialog', 'Prognosis', '$location', function(toastService, $mdDialog, Prognosis, $location){
    return new PrognosisController(toastService, $mdDialog, Prognosis, $location);
}])
    .component("rkcPrognosis", new PrognosisOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/prognosis.ts
 **/